<template>
  <transition name="Swipe">
    <div
      class="Nav Nav_mobile"
      v-if="forms.mobileMenu.opened"
      @click.self="manageMenu(false)"
    >
      <div class="Nav__inner">
        <div class="Nav__layout">
          <ul class="Nav__menu">
            <li class="Nav__menu-item" @click="manageMenu(false)">
              <router-link to="/" class="Nav__menu-link">
                <div>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M31.1376 13.9185C31.1366 13.9177 31.1358 13.9168 31.1351 13.916L18.0816 0.863039C17.5252 0.306397 16.7855 0 15.9986 0C15.2117 0 14.472 0.306397 13.9153 0.863039L0.868687 13.9094C0.864293 13.9138 0.859654 13.9185 0.855504 13.9229C-0.287077 15.072 -0.285124 16.9366 0.861119 18.0828C1.3848 18.6067 2.07621 18.9099 2.81571 18.9419C2.84599 18.9449 2.87626 18.9463 2.90678 18.9463H3.4268V28.5523C3.4268 30.4534 4.97368 32.0001 6.8748 32.0001H11.9818C12.4996 32.0001 12.9193 31.5801 12.9193 31.0626V23.5313C12.9193 22.6639 13.6251 21.9583 14.4925 21.9583H17.5047C18.3721 21.9583 19.0777 22.6639 19.0777 23.5313V31.0626C19.0777 31.5801 19.4974 32.0001 20.0152 32.0001H25.1222C27.0235 32.0001 28.5702 30.4534 28.5702 28.5523V18.9463H29.0526C29.8392 18.9463 30.579 18.6399 31.1358 18.083C32.2833 16.9351 32.2838 15.0672 31.1376 13.9185ZM29.8099 16.7574C29.6075 16.9597 29.3385 17.0713 29.0526 17.0713H27.6327C27.1148 17.0713 26.6952 17.491 26.6952 18.0088V28.5523C26.6952 29.4195 25.9896 30.1251 25.1222 30.1251H20.9527V23.5313C20.9527 21.6302 19.4061 20.0833 17.5047 20.0833H14.4925C12.5911 20.0833 11.0442 21.6302 11.0442 23.5313V30.1251H6.8748C6.00762 30.1251 5.3018 29.4195 5.3018 28.5523V18.0088C5.3018 17.491 4.88212 17.0713 4.3643 17.0713H2.96879C2.95414 17.0703 2.93974 17.0696 2.92484 17.0694C2.64555 17.0645 2.38358 16.9536 2.18729 16.7571C1.76981 16.3396 1.76981 15.6602 2.18729 15.2425C2.18705 15.2427 2.18754 15.2425 2.18729 15.2425L15.2415 2.18872C15.4437 1.98633 15.7125 1.875 15.9986 1.875C16.2845 1.875 16.5533 1.98633 16.7557 2.18872L29.8058 15.2386C29.8077 15.2405 29.8099 15.2425 29.8119 15.2444C30.2272 15.6626 30.2264 16.3406 29.8099 16.7574Z"
                      fill="white"
                    />
                  </svg>
                  <span>{{ $t("VUE.MAIN_PAGE") }}</span>
                </div>
              </router-link>
            </li>
            <li class="Nav__menu-item" @click="manageMenu(false)">
              <router-link to="/news" class="Nav__menu-link">
                <div>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.1875 1.93749C17.1875 1.38521 16.7398 0.937493 16.1875 0.937493C15.6352 0.937493 15.1875 1.38521 15.1875 1.93749H17.1875ZM15.1875 30.0625C15.1875 30.6148 15.6352 31.0625 16.1875 31.0625C16.7398 31.0625 17.1875 30.6148 17.1875 30.0625H15.1875ZM2.125 15C1.57272 15 1.125 15.4477 1.125 16C1.125 16.5523 1.57272 17 2.125 17V15ZM30.25 17C30.8023 17 31.25 16.5523 31.25 16C31.25 15.4477 30.8023 15 30.25 15V17ZM28.375 10.5H23.125V12.5H28.375V10.5ZM23.125 10.5C22.2298 10.5 21.5 9.77022 21.5 8.87501H19.5C19.5 10.8748 21.1252 12.5 23.125 12.5V10.5ZM21.5 8.87501V3.625H19.5V8.87501H21.5ZM21.5 3.625C21.5 2.72979 22.2298 2 23.125 2V0C21.1252 0 19.5 1.62522 19.5 3.625H21.5ZM23.125 2H28.375V0H23.125V2ZM28.375 2C29.2702 2 30 2.72979 30 3.625H32C32 1.62522 30.3748 0 28.375 0V2ZM30 3.625V8.87501H32V3.625H30ZM30 8.87501C30 9.77022 29.2702 10.5 28.375 10.5V12.5C30.3748 12.5 32 10.8748 32 8.87501H30ZM28.375 30H23.125V32H28.375V30ZM23.125 30C22.2298 30 21.5 29.2702 21.5 28.375H19.5C19.5 30.3748 21.1252 32 23.125 32V30ZM21.5 28.375V23.125H19.5V28.375H21.5ZM21.5 23.125C21.5 22.2298 22.2298 21.5 23.125 21.5V19.5C21.1252 19.5 19.5 21.1252 19.5 23.125H21.5ZM23.125 21.5H28.375V19.5H23.125V21.5ZM28.375 21.5C29.2702 21.5 30 22.2298 30 23.125H32C32 21.1252 30.3748 19.5 28.375 19.5V21.5ZM30 23.125V28.375H32V23.125H30ZM30 28.375C30 29.2702 29.2702 30 28.375 30V32C30.3748 32 32 30.3748 32 28.375H30ZM8.87501 30H3.625V32H8.87501V30ZM3.625 30C2.72978 30 2 29.2702 2 28.375H0C0 30.3748 1.62522 32 3.625 32V30ZM2 28.375V23.125H0V28.375H2ZM2 23.125C2 22.2298 2.72978 21.5 3.625 21.5V19.5C1.62522 19.5 0 21.1252 0 23.125H2ZM3.625 21.5H8.87501V19.5H3.625V21.5ZM8.87501 21.5C9.77022 21.5 10.5 22.2298 10.5 23.125H12.5C12.5 21.1252 10.8748 19.5 8.87501 19.5V21.5ZM10.5 23.125V28.375H12.5V23.125H10.5ZM10.5 28.375C10.5 29.2702 9.77022 30 8.87501 30V32C10.8748 32 12.5 30.3748 12.5 28.375H10.5ZM8.87501 10.5H3.625V12.5H8.87501V10.5ZM3.625 10.5C2.72978 10.5 2 9.77022 2 8.87501H0C0 10.8748 1.62522 12.5 3.625 12.5V10.5ZM2 8.87501V3.625H0V8.87501H2ZM2 3.625C2 2.72979 2.72979 2 3.625 2V0C1.62522 0 0 1.62522 0 3.625H2ZM3.625 2H8.87501V0H3.625V2ZM8.87501 2C9.77022 2 10.5 2.72978 10.5 3.625H12.5C12.5 1.62522 10.8748 0 8.87501 0V2ZM10.5 3.625V8.87501H12.5V3.625H10.5ZM10.5 8.87501C10.5 9.77022 9.77022 10.5 8.87501 10.5V12.5C10.8748 12.5 12.5 10.8748 12.5 8.87501H10.5ZM15.1875 1.93749V16H17.1875V1.93749H15.1875ZM15.1875 16V30.0625H17.1875V16H15.1875ZM2.125 17H16.1875V15H2.125V17ZM16.1875 17H30.25V15H16.1875V17Z"
                      fill="white"
                    />
                  </svg>
                  <span>{{ $t("HOME") }}</span>
                </div>
              </router-link>
            </li>
            <li
              class="Nav__menu-item"
              @click="
                manageMenu(false),
                  managePopupState({ popup: 'partnersForm', _state: true })
              "
            >
              <a href="#" class="Nav__menu-link">
                <div>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.1875 1.93749C17.1875 1.38521 16.7398 0.937493 16.1875 0.937493C15.6352 0.937493 15.1875 1.38521 15.1875 1.93749H17.1875ZM15.1875 30.0625C15.1875 30.6148 15.6352 31.0625 16.1875 31.0625C16.7398 31.0625 17.1875 30.6148 17.1875 30.0625H15.1875ZM2.125 15C1.57272 15 1.125 15.4477 1.125 16C1.125 16.5523 1.57272 17 2.125 17V15ZM30.25 17C30.8023 17 31.25 16.5523 31.25 16C31.25 15.4477 30.8023 15 30.25 15V17ZM28.375 10.5H23.125V12.5H28.375V10.5ZM23.125 10.5C22.2298 10.5 21.5 9.77022 21.5 8.87501H19.5C19.5 10.8748 21.1252 12.5 23.125 12.5V10.5ZM21.5 8.87501V3.625H19.5V8.87501H21.5ZM21.5 3.625C21.5 2.72979 22.2298 2 23.125 2V0C21.1252 0 19.5 1.62522 19.5 3.625H21.5ZM23.125 2H28.375V0H23.125V2ZM28.375 2C29.2702 2 30 2.72979 30 3.625H32C32 1.62522 30.3748 0 28.375 0V2ZM30 3.625V8.87501H32V3.625H30ZM30 8.87501C30 9.77022 29.2702 10.5 28.375 10.5V12.5C30.3748 12.5 32 10.8748 32 8.87501H30ZM28.375 30H23.125V32H28.375V30ZM23.125 30C22.2298 30 21.5 29.2702 21.5 28.375H19.5C19.5 30.3748 21.1252 32 23.125 32V30ZM21.5 28.375V23.125H19.5V28.375H21.5ZM21.5 23.125C21.5 22.2298 22.2298 21.5 23.125 21.5V19.5C21.1252 19.5 19.5 21.1252 19.5 23.125H21.5ZM23.125 21.5H28.375V19.5H23.125V21.5ZM28.375 21.5C29.2702 21.5 30 22.2298 30 23.125H32C32 21.1252 30.3748 19.5 28.375 19.5V21.5ZM30 23.125V28.375H32V23.125H30ZM30 28.375C30 29.2702 29.2702 30 28.375 30V32C30.3748 32 32 30.3748 32 28.375H30ZM8.87501 30H3.625V32H8.87501V30ZM3.625 30C2.72978 30 2 29.2702 2 28.375H0C0 30.3748 1.62522 32 3.625 32V30ZM2 28.375V23.125H0V28.375H2ZM2 23.125C2 22.2298 2.72978 21.5 3.625 21.5V19.5C1.62522 19.5 0 21.1252 0 23.125H2ZM3.625 21.5H8.87501V19.5H3.625V21.5ZM8.87501 21.5C9.77022 21.5 10.5 22.2298 10.5 23.125H12.5C12.5 21.1252 10.8748 19.5 8.87501 19.5V21.5ZM10.5 23.125V28.375H12.5V23.125H10.5ZM10.5 28.375C10.5 29.2702 9.77022 30 8.87501 30V32C10.8748 32 12.5 30.3748 12.5 28.375H10.5ZM8.87501 10.5H3.625V12.5H8.87501V10.5ZM3.625 10.5C2.72978 10.5 2 9.77022 2 8.87501H0C0 10.8748 1.62522 12.5 3.625 12.5V10.5ZM2 8.87501V3.625H0V8.87501H2ZM2 3.625C2 2.72979 2.72979 2 3.625 2V0C1.62522 0 0 1.62522 0 3.625H2ZM3.625 2H8.87501V0H3.625V2ZM8.87501 2C9.77022 2 10.5 2.72978 10.5 3.625H12.5C12.5 1.62522 10.8748 0 8.87501 0V2ZM10.5 3.625V8.87501H12.5V3.625H10.5ZM10.5 8.87501C10.5 9.77022 9.77022 10.5 8.87501 10.5V12.5C10.8748 12.5 12.5 10.8748 12.5 8.87501H10.5ZM15.1875 1.93749V16H17.1875V1.93749H15.1875ZM15.1875 16V30.0625H17.1875V16H15.1875ZM2.125 17H16.1875V15H2.125V17ZM16.1875 17H30.25V15H16.1875V17Z"
                      fill="white"
                    />
                  </svg>
                  <span>{{ $t("FOR_PARTNERS") }}</span>
                </div>
              </a>
            </li>
            <li
              class="Nav__menu-item"
              @click="
                manageMenu(false),
                  managePopupState({ popup: 'volunteersForm', _state: true })
              "
            >
              <a href="#" class="Nav__menu-link">
                <div>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.1875 1.93749C17.1875 1.38521 16.7398 0.937493 16.1875 0.937493C15.6352 0.937493 15.1875 1.38521 15.1875 1.93749H17.1875ZM15.1875 30.0625C15.1875 30.6148 15.6352 31.0625 16.1875 31.0625C16.7398 31.0625 17.1875 30.6148 17.1875 30.0625H15.1875ZM2.125 15C1.57272 15 1.125 15.4477 1.125 16C1.125 16.5523 1.57272 17 2.125 17V15ZM30.25 17C30.8023 17 31.25 16.5523 31.25 16C31.25 15.4477 30.8023 15 30.25 15V17ZM28.375 10.5H23.125V12.5H28.375V10.5ZM23.125 10.5C22.2298 10.5 21.5 9.77022 21.5 8.87501H19.5C19.5 10.8748 21.1252 12.5 23.125 12.5V10.5ZM21.5 8.87501V3.625H19.5V8.87501H21.5ZM21.5 3.625C21.5 2.72979 22.2298 2 23.125 2V0C21.1252 0 19.5 1.62522 19.5 3.625H21.5ZM23.125 2H28.375V0H23.125V2ZM28.375 2C29.2702 2 30 2.72979 30 3.625H32C32 1.62522 30.3748 0 28.375 0V2ZM30 3.625V8.87501H32V3.625H30ZM30 8.87501C30 9.77022 29.2702 10.5 28.375 10.5V12.5C30.3748 12.5 32 10.8748 32 8.87501H30ZM28.375 30H23.125V32H28.375V30ZM23.125 30C22.2298 30 21.5 29.2702 21.5 28.375H19.5C19.5 30.3748 21.1252 32 23.125 32V30ZM21.5 28.375V23.125H19.5V28.375H21.5ZM21.5 23.125C21.5 22.2298 22.2298 21.5 23.125 21.5V19.5C21.1252 19.5 19.5 21.1252 19.5 23.125H21.5ZM23.125 21.5H28.375V19.5H23.125V21.5ZM28.375 21.5C29.2702 21.5 30 22.2298 30 23.125H32C32 21.1252 30.3748 19.5 28.375 19.5V21.5ZM30 23.125V28.375H32V23.125H30ZM30 28.375C30 29.2702 29.2702 30 28.375 30V32C30.3748 32 32 30.3748 32 28.375H30ZM8.87501 30H3.625V32H8.87501V30ZM3.625 30C2.72978 30 2 29.2702 2 28.375H0C0 30.3748 1.62522 32 3.625 32V30ZM2 28.375V23.125H0V28.375H2ZM2 23.125C2 22.2298 2.72978 21.5 3.625 21.5V19.5C1.62522 19.5 0 21.1252 0 23.125H2ZM3.625 21.5H8.87501V19.5H3.625V21.5ZM8.87501 21.5C9.77022 21.5 10.5 22.2298 10.5 23.125H12.5C12.5 21.1252 10.8748 19.5 8.87501 19.5V21.5ZM10.5 23.125V28.375H12.5V23.125H10.5ZM10.5 28.375C10.5 29.2702 9.77022 30 8.87501 30V32C10.8748 32 12.5 30.3748 12.5 28.375H10.5ZM8.87501 10.5H3.625V12.5H8.87501V10.5ZM3.625 10.5C2.72978 10.5 2 9.77022 2 8.87501H0C0 10.8748 1.62522 12.5 3.625 12.5V10.5ZM2 8.87501V3.625H0V8.87501H2ZM2 3.625C2 2.72979 2.72979 2 3.625 2V0C1.62522 0 0 1.62522 0 3.625H2ZM3.625 2H8.87501V0H3.625V2ZM8.87501 2C9.77022 2 10.5 2.72978 10.5 3.625H12.5C12.5 1.62522 10.8748 0 8.87501 0V2ZM10.5 3.625V8.87501H12.5V3.625H10.5ZM10.5 8.87501C10.5 9.77022 9.77022 10.5 8.87501 10.5V12.5C10.8748 12.5 12.5 10.8748 12.5 8.87501H10.5ZM15.1875 1.93749V16H17.1875V1.93749H15.1875ZM15.1875 16V30.0625H17.1875V16H15.1875ZM2.125 17H16.1875V15H2.125V17ZM16.1875 17H30.25V15H16.1875V17Z"
                      fill="white"
                    />
                  </svg>
                  <span>{{ $t("FOR_VOLUNTEERS") }}</span>
                </div>
              </a>
            </li>
          </ul>
          <div class="Nav__footer">
            <Share wrapper="Nav" :icons="share.icons" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Share } from "@/components/app";
import { mapMutations, mapGetters } from "vuex";
export default {
  name: "MobileMenu",
  data: () => ({
    share: {
      icons: [
        {
          src: require("@/assets/images/1PH2sk9KKpJNYT-baEFlpw.svg"),
          alt: "vk"
        },
        {
          src: require("@/assets/images/39bQ1s4_B8Uit750tn8fxk.svg"),
          alt: "facebook"
        },
        {
          src: require("@/assets/images/31iKawYVsldFlibQv6hKhf.svg"),
          alt: "linkedin"
        }
      ]
    }
  }),
  methods: {
    ...mapMutations(["managePopupState"]),
    manageMenu(state) {
      this.managePopupState({ popup: "mobileMenu", _state: state });
    }
  },
  computed: mapGetters(["forms"]),
  components: {
    Share
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.Nav.Nav_mobile {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(#000, 0.1);

  .Nav__inner {
    position: absolute;
    right: 0;
    width: 80%;
    min-height: 100vh;
    background-color: $aux_bg;
    overflow-y: auto;
  }

  .Nav__layout {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .Nav__menu {
    padding: 20px 0;

    &-link {
      display: flex;
      padding: 10px 20px;
      line-height: 1;
      transition: background-color 0.2s;

      div {
        display: flex;
        align-items: center;
      }

      span {
        margin: 0 0 0 40px;
        font-size: 18px;
        color: $sec_c;
      }

      svg {
        min-width: 32px;
      }

      &:hover {
        background-color: lighten($aux_bg, 5%);
      }
    }

    &-item + .Nav__menu-item {
      border-top: 1.5px solid lighten($color: $aux_bg, $amount: 10%);
    }
  }

  .Nav__footer {
    display: flex;
    justify-content: center;
    padding: 30px 0;
  }

  .Nav__share {
    margin: 0;
    padding: 7.5px 10px;
  }

  @media screen and (min-width: $max-md) {
    .Nav__share {
      span::before {
        content: "Поделиться:";
      }
    }
  }

  &::-webkit-scrollbar {
    width: 0.2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $aux_bg;
  }
}

.Swipe-enter-active,
.Swipe-leave-active {
  transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.Swipe-enter,
.Swipe-leave-to {
  transform: translateX(100%);
}
</style>
